export default "__VITE_ASSET__CrLjoqWy__"